module.exports = __webpack_public_path__ + "static/fifth_user_image2-bcaa92752319e71125a0832207d0ea87.jpg";